export { BrandFacet } from './BrandFacet'
export type { BrandFacetProps } from './BrandFacet'
